var RwAjaxRiservata = (function () {

  // GESTORE - REGISTRA GESTORE
  // Registrazione nuovo gestore in template nuova-attivita.php
  var registra_gestore = function (checkmail) {

    if(localStorage.getItem('rwgestsecret') !== null){
      tokenLS = localStorage.getItem('rwgestsecret');
    } else {
      tokenLS = 'notoken';
    }

    if($('body').hasClass('pc_logged')){
      logged = true;
    } else {
      logged = false;
    }

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_registra_gestore',              // Funzione php in inc/moduli/func-ajax-riservata
        security : rw_ajax_obj.ajax_nonce,                // Security definita in inc/enqueue.php da rw_ajax_obj
        pcma_key : RwUtil.getUrlParam('pcma_key'),
        local_token : tokenLS,
        check_mail : checkmail,
        logged : logged
      },
      beforeSend: function() {
      },
      success : function( response ) {
        // Popolo html in base alle condizioni espresse in inc/moduli/func-ajax-riservata
        // se esiste il modale accedi siamo in una pagina con doc riservati e popoliamo il modale
        if(document.getElementById('accedi-registrati')){

          $('#accedi-registrati .modal-body #LogRegContent #registerarea').html( response );

        // altrimenti siamo nella pagina di atterraggio
        } else {
          $('main .entry-content').html( response );
        }
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){

        if(!RwUtil.getUrlParam('pcma_key')){
          // STEP 1 -> REGISTRA GESTORE
          RwClassRiservata.RegistraGestore();

          // STEP 2 -> CONTROLLA MAIL
          // parte quando appare il messaggio di success del form
          $('body').on('DOMSubtreeModified', '.pc_registration_form .pc_form_response', function() {
            // faccio ripartire la chiamata con il parametro per il check mail

            if($(this).children().hasClass('pc_success_mess')){

              // ATTENZIONE!!! SCOMMENTA QUESTO E ATTIVA MAIL ACTION PER ATTIVARE AUTOLOGIN
              registra_gestore('check');

              // Poi abilita "Impostare lo stato degli utenti come in sospeso dopo la registrazione?"
              // e mail-actions -> "Enable users verification?"
              // E COMMENTA QUESTE 4 RIGHE
              // setTimeout(function(){
              //   $('#accedi-registrati .modal-body #LogRegContent #loginarea').append('Inserisci Email e Password per accedere');
              //   $('#accedi-registrati #loginarea-tab').click();
              // }, 1500);
            }
          });

        } else {

          if(localStorage.getItem('rwgestsecret')){
            // STEP 2a -> LOGIN AUTOMATICO
            // se apro la mail sullo stesso browser di registrazione
            RwClassRiservata.AutoLoginGestore();
            localStorage.removeItem('rwgestsecret');

          } else {
            // STEP 2b -> LOGIN MANUALE
            // se apro la mail su browser diverso da registrazione
          }

        }
      }
    });
  };



  // GESTORE - AUTOLOGIN
  // dopo la registrazione, all'apertura della email di conferma
  var autologin_gest = function (usr, psw, usrId) {

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_autologin_gestore',  // Funzione php in inc/moduli/func-ajax-riservata
        security : rw_ajax_obj.ajax_nonce,    // Security definita in inc/enqueue.php da rw_ajax_obj
        usr: usr,
        psw: psw,
        usrId : usrId
      },
      beforeSend: function() {
        console.log('ajaxUsr: ' + usr + ' ajaxPsw: ' + psw);
      },
      success : function( response ) {
        window.location.href = JSON.parse(response);
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
      }
    });
  };


  // MODALE LOGIN -REGISTRAZIONE
  // Modale Login / Registrazione
  var login_register = function (template) {

    $.ajax({
      url : rw_ajax_obj.ajax_url,
      type : 'post',
      data : {
        action : 'rw_ajax_login_register',  // Funzione php in inc/moduli/func-ajax-riservata
        security : rw_ajax_obj.ajax_nonce,  // Security definita in inc/enqueue.php da rw_ajax_obj
        template : template
      },
      beforeSend: function() {
      },
      success : function( response ) {
        $('#accedi-registrati .modal-body').html( response );
      },
      error: function( jqXHR, textStatus, errorThrown ){
        console.log( 'Errore: ' + textStatus, errorThrown );
      },
      complete: function( jqXHR, textStatus ){
        RwAjaxRiservata.RegistraGestore();
        // Bootstrap 5: $.fn.modal removed — use the JS API
        var el = document.getElementById('accedi-registrati');
        if (el && window.bootstrap && bootstrap.Modal) {
          bootstrap.Modal.getOrCreateInstance(el).show();
        }
      }
    });
  };



  return {
    RegistraGestore : registra_gestore,
    AjaxLoginGestore : autologin_gest,
    LogReg : login_register
  }


})();
